import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  TabsModule,
  FilterModule,
  PaginationModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  AutocompleteModule,
  ViewTableModule,
  ComboModule,
  DaterangepickerModule,
  SharedModule,
} from 'beyond-util';
import { MediaPlanComponent } from './media-plan.component';
import { MediaPlanDetailsComponent } from '../../components/media-plan-details/media-plan-details.component';

@NgModule({
  declarations: [MediaPlanComponent, MediaPlanDetailsComponent],
  entryComponents: [MediaPlanComponent, MediaPlanDetailsComponent],
  exports: [MediaPlanComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    PaginationModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    AutocompleteModule,
    ComboModule,
    ViewTableModule,
    DaterangepickerModule,
    SharedModule,
    TooltipModule,
    NgxSpinnerModule,
  ],
})
export class MediaPlanModule {}



// WEBPACK FOOTER //
// ./src/app/pages/media-plan/media-plan.module.ts